<template>
  <div>
    <h1>Dashboard</h1>
    <v-row align="start" justify="center">

      <v-col md="3">
        <v-card
          class="mx-auto"
          color="primary"
          dark
          min-width="150"
          max-width="400"
        >
          <v-card-title>
            <v-icon large left> mdi-book </v-icon>
            <span class="title font-weight-light">Publications</span>
          </v-card-title>
          <v-divider class="divider"></v-divider>
          <v-card-text class="cardText">
            <div>
              <div class="count">{{ data.PublicationCount }}</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

         <v-col md="3">
        <v-card
          class="mx-auto"
          color="primary"
          dark
          min-width="150"
          max-width="400"
        >
          <v-card-title>
            <v-icon large left> mdi-book </v-icon>
            <span class="title font-weight-light">Journals</span>
          </v-card-title>
          <v-divider class="divider"></v-divider>
          <v-card-text class="cardText">
            <div>
              <div class="count">{{ data.JournalCount }}</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col md="3">
        <v-card
          class="mx-auto"
          color="primary"
          dark
          min-width="150"
          max-width="400"
        >
          <v-card-title>
            <v-icon large left> mdi-account </v-icon>
            <span class="title font-weight-light">Users</span>
          </v-card-title>
          <v-divider class="divider"></v-divider>
          <v-card-text class="cardText">
            <div>
              <div class="count">{{ data.UserCount }}</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="3">
        <v-card
          class="mx-auto"
          color="primary"
          dark
          min-width="150"
          max-width="400"
        >
          <v-card-title>
            <v-icon large left> mdi-library-books </v-icon>
            <span class="title font-weight-light">Collections</span>
          </v-card-title>
          <v-divider class="divider"></v-divider>
          <v-card-text class="cardText">
            <div>
              <div class="count">{{ data.CollectionCount }}</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col md="3">
        <v-card
          class="mx-auto"
          color="primary"
          dark
          min-width="150"
          max-width="400"
        >
          <v-card-title>
            <v-icon large left> mdi-library-books </v-icon>
            <span class="title font-weight-light">Organizations</span>
          </v-card-title>
          <v-divider class="divider"></v-divider>
          <v-card-text class="cardText">
            <div>
              <div class="count">{{ data.OrganizationCount }}</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col md="3">
        <v-card
          class="mx-auto"
          color="primary"
          dark
          min-width="150"
          max-width="400"
        >
          <v-card-title>
            <v-icon large left> mdi-library-books </v-icon>
            <span class="title font-weight-light">Purchase Orders</span>
          </v-card-title>
          <v-divider class="divider"></v-divider>
          <v-card-text class="cardText">
            <div>
              <div class="count">{{ data.PurchaseOrderCount }}</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <!--  
      <v-col md="3">
        <v-card class="mx-auto" color="#1976d2" dark min-width="150" max-width="400">
          <v-card-title>
            <v-icon large left> mdi-license </v-icon>
            <span class="title font-weight-light">Licenses</span>
          </v-card-title>
          <v-divider class="divider"></v-divider>
          <v-card-text class="cardText">
            <div>
              <div class="count">{{data.LicenseCount}}</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col> 
       

         <v-col md="3">
        <v-card class="mx-auto" color="#1976d2" dark min-width="150" max-width="400">
          <v-card-title>
            <v-icon large left> mdi-account-multiple </v-icon>
            <span class="title font-weight-light">Groups</span>
          </v-card-title>
          <v-divider class="divider"></v-divider>
          <v-card-text class="cardText">
            <div>
              <div class="count">{{data.GroupCount}}</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
         <v-col md="3">
        <v-card class="mx-auto" color="#1976d2" dark min-width="150" max-width="400">
          <v-card-title>
            <v-icon large left> mdi-book-plus </v-icon>
            <span class="title font-weight-light">User Subscriptions</span>
          </v-card-title>
          <v-divider class="divider"></v-divider>
          <v-card-text class="cardText">
            <div>
              <div class="count">{{data.UserSubscriptionCount}}</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
         <v-col md="3">
        <v-card class="mx-auto" color="#1976d2" dark min-width="150" max-width="400">
          <v-card-title>
            <v-icon large left> mdi-book-plus-multiple</v-icon>
            <span class="title font-weight-light">Group Subscriptions</span>
          </v-card-title>
          <v-divider class="divider"></v-divider>
          <v-card-text class="cardText">
            <div>
              <div class="count">{{data.GroupSubscriptionCount}}</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col> -->
      <v-col></v-col>
    </v-row>

    <h1 class="mt-5">Purchase Order (last 7 days)</h1>

    <v-card elevation="2">
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Date</th>
              <th style="width: 150px">PO Count</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="item in list" :key="item.Title">
              <td>{{ item.date }}</td>
              <td>{{ item.count }}</td>
            </tr>
          </tbody>

         <!-- <Chart :chartData="chartData" :chartOptions="chartOptions" :chartType="chartType" /> -->
        </template>
      </v-simple-table>
    </v-card>
  </div>
</template>

<script>
import * as api from "@/api";
import Chart from "./../components/Chart.vue";

export default {
  name: "Dashboard",
  components: {
    Chart
  },
  created() {
    this.geStatistic();
    //this.getBestPublications();
    this.getPurchaseOrder();
  },
  methods: {
    geStatistic() {
      new Promise((resolve, reject) => {
        api
          .getAll("dashboard")
          .then((response) => {
            //console.log(response);
            this.data = response.data[0];
            console.log(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getBestPublications() {
      new Promise((resolve, reject) => {
        api
          .getAll("dashboard/best-publications")
          .then((response) => {
            this.list = response.data;
            console.log(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getPurchaseOrder() {
      new Promise((resolve, reject) => {
        api
          .getAll("dashboard/purchase-orders")
          .then((response) => {
            //console.log(response);
            this.list = response.data;
            console.log(response.data);

            //debugger;
            this.chartData.labels = []
            response.data.forEach(element => {
              this.chartData.labels.push(element.date)
                //chartData.datasets.data.push(element.data)
            });

          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  data() {
    return {
      data: {},
      list: [],
      chartType: "bar",
      chartData: {
        labels: ['January'],  //, 'February', 'March'
        datasets: [ { data: [10],borderColor: '#2554FF',backgroundColor: '#2554FF', } ]
      },
      chartOptions: {
        responsive: true
      },
      chartOptions: {
        scales: {
          xAxes: [
            {
              stacked: true,
              gridLines: { display: false },
            },
          ],
          yAxes: [
            {
              ticks: {
                stepSize: 1,
                callback: function(value, index, values) {
                  if (value % Math.round(values[0] / 6) == 0) {
                    return value;
                  } else if (value === 0) {
                    return value;
                  }
                },
              },
              // stacked: true
            },
          ],
        },
        maintainAspectRatio: false,
        legend: {
          labels: {
            boxWidth: 10,
          },
          position: "top",
        },
        animation: {
          duration: 2000,
          easing: "easeInOutQuart",
        },
      },
    };
  },
};
</script>
<style scoped>
.count {
  font-size: 72px;
  font-weight: 400;
  text-align: center;
  margin-top: 20px;
  color: white;
}
.cardText {
  height: 100px;
}
.title {
  text-align: center;
}
.divider {
  color: white;
  border-width: 1px;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard.vue